import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#2E3137",
  d: "M12.342 7.5q-.568 0-.964-.401a1.33 1.33 0 0 1-.397-.968q0-.567.4-.965.401-.396.97-.397.566 0 .963.401.398.401.398.969t-.401.964-.969.397M11 18.962v-4.616h-1V9.923q0-.555.396-.95.395-.396.95-.396h2q.555 0 .951.395t.396.951v4.423h-1v4.616zM19.342 7.5q-.568 0-.964-.401a1.33 1.33 0 0 1-.397-.968q0-.567.4-.965.401-.396.97-.397.566 0 .963.401.398.401.398.969t-.401.964-.969.397M18 18.962v-4.616h-1V9.923q0-.555.395-.95.396-.396.951-.396h2q.555 0 .951.395t.395.951v4.423h-1v4.616zM5.342 7.5q-.568 0-.964-.401a1.33 1.33 0 0 1-.397-.968q0-.567.4-.965.401-.396.97-.397.566 0 .963.401.398.401.398.969t-.401.964-.969.397M4 18.962v-4.616H3V9.923q0-.555.396-.95.395-.396.95-.396h2q.555 0 .951.395t.396.951v4.423h-1v4.616z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }